import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Form,
  Modal,
  Popconfirm,
  Select,
  Image,
  Drawer,
  Input,
  Tag,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../../utils/auth";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import ShopLayout from "../Layout";
import _ from "lodash";
import ShopHeader from "../Layout/topHeader";
import { getParamValue, getQueryParams } from "../../../utils/index";
import Meta from "antd/lib/card/Meta";
import AddProduct from "../../products/AddProduct";
import CategoryProductDetails from "./details";

const ShopCategory = () => {
  const [type, setType] = useState<string>("JC_MART");
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(16);
  const [visible, setVisible] = useState(undefined);
  const [selectedProductSlug, setSelectedProductSlug] = useState(undefined);
  const [selectedCategoryId, setSelectedCategoryId] = useState(undefined);
  const [selectedProductForEdit, setSelectedProductForEdit] =
    useState(undefined);

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoryId, setCategoryId] = useState<any>();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [productsData, setProductsData] = useState({
    loading: false,
    data: null,
  });
  const route: any = useParams();
  const history: any = useHistory();

  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [form] = Form.useForm();
  const router = useLocation();
  const page = getParamValue(router?.search, "page");

  // All Category List For Add Category
  const getCategoriesOptions = useCallback(async () => {
    if (type) {
      setCategoriesOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/category/child-category-by-parent?categoryId=${route?.categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setCategoriesOptions({
        loading: false,
        list: res?.data?.categories,
      });
    } else {
      responseNotification("Select a type before searching", "warning");
    }
  }, [route?.categoryId, type]);

  useEffect(() => {
    if (type) {
      getCategoriesOptions();
    }
  }, [getCategoriesOptions, type]);

  // Category List By Shop ID
  // const getShopCategory = useCallback((getShopId) => {
  //   if (getShopId) {
  //     try {
  //       setProductsData({ loading: true, data: undefined });
  //       axios
  //         .get(
  //           `${process.env.REACT_APP_CATALOG_READER_API}/shop/categories?shopId=${getShopId}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${authenticateToken()}`,
  //               "Content-Type": "application/json",
  //             },
  //           }
  //         )
  //         .then((data) => {
  //           if (data.status === 200) {
  //             setProductsData({
  //               loading: false,
  //               data: data?.data,
  //             });
  //           } else {
  //             setProductsData({ loading: false, data: null });
  //             responseNotification(
  //               data.statusText || "something went wrong",
  //               "error"
  //             );
  //           }
  //         })
  //         .catch((err) => {
  //           setProductsData({ loading: false, data: null });

  //           console.log(err);
  //         });
  //     } catch (error) {
  //       setProductsData({ loading: false, data: null });

  //       console.log(error, "error");
  //     }
  //   }
  // }, []);

  const getShopCategoryProducts = useCallback(
    (getShopId) => {
      if (getShopId) {
        try {
          setProductsData({ loading: true, data: undefined });
          axios
            .get(
              `${process.env.REACT_APP_CATALOG_READER_API}/admin/product?shopId=${getShopId}` +
                `&categoryId=${selectedCategory?.id || route?.categoryId}` +
                `&page=${page || 0}` +
                `&limit=${limit || 16}` +
                (type ? `&type=${type}` : ``),
              {
                headers: {
                  Authorization: `Bearer ${authenticateToken()}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setProductsData({
                  loading: false,
                  data: data?.data,
                });
              } else {
                setProductsData({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setProductsData({ loading: false, data: null });
              console.log(err);
            });
        } catch (error) {
          setProductsData({ loading: false, data: null });
          console.log(error, "error");
        }
      }
    },
    [route?.categoryId, selectedCategory, page, limit]
  );

  // useEffect(() => {
  //   getShopCategory((route as any)?.shopId);
  // }, [getShopCategory, route]);

  useEffect(() => {
    getShopCategoryProducts((route as any)?.shopId);
  }, [getShopCategoryProducts, route]);

  const onSubmit = async (data) => {
    if (setSelectedCategoryId) {
      setLoading(true);

      const readyData = data && {
        categoryId: selectedCategoryId?.id,
        shopId: (route as any)?.shopId,
        // position: data.position * 1,
        displayOrder: data.displayOrder * 1,
        deleted: false,
      };

      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-shop`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Category Updated Successfully", "success");
            getCategoriesOptions();
            form.resetFields();
            handleOk();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      responseNotification("Please Selecet Valid Category");
    }
  };

  const onDelete = async (id) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          categoryId: id,
          shopId: (route as any)?.shopId,
          deleted: true,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Category Deleted Successfully", "success");
            history.push(".");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const showPopconfirm = (id) => {
    setVisible(id);
  };

  const handleOk = () => {
    setSelectedCategoryId(undefined);
  };

  const handleCancel = () => {
    setVisible(undefined);
    setSelectedCategoryId(undefined);
  };

  useEffect(() => {
    if (visible) {
      setSelectedCategory(undefined);
    }
  }, [selectedCategory, visible]);

  useEffect(() => {
    setSelectedCategory(undefined);
  }, [visible]);

  useEffect(() => {
    if (!route?.categoryId) {
      history?.replaceState(".");
    }
  }, [history, route?.categoryId]);

  const onClose = () => {
    setSelectedProductSlug(null);
    setSelectedProductForEdit(undefined);
    // getShopCategoryProducts();
  };

  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="product-list-item-area white-bg">
          <ShopHeader
            leftarea={getParamValue(window?.location.search, "name")}
            rightarea={
              <div className="">
                <Button
                  className="mr-2"
                  type="ghost"
                  onClick={() => {
                    setSelectedCategoryId({
                      id: (route as any)?.categoryId,
                      name: getParamValue(window?.location.search, "name"),
                    });
                  }}
                >
                  <EditOutlined /> Edit{" "}
                </Button>

                <Popconfirm
                  placement="left"
                  title={
                    <>
                      Are you sure to delete this category? <br />
                      <span style={{ color: "gray" }}>
                        (NB-All subcategories & Products under <br /> this
                        category will also be deleted)
                      </span>
                    </>
                  }
                  visible={!!visible}
                  onConfirm={() => onDelete(route?.categoryId)}
                  okButtonProps={{ loading: confirmLoading }}
                  onCancel={handleCancel}
                >
                  <Button
                    danger
                    type="primary"
                    icon={<DeleteOutlined />}
                    title="Delete this category"
                    onClick={() => showPopconfirm(route?.categoryId)}
                  >
                    Delete
                  </Button>
                </Popconfirm>

                <Modal
                  title={`Edit Category - (${selectedCategoryId?.name})`}
                  visible={!!selectedCategoryId}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  footer={null}
                >
                  <Form
                    name="control-hooks"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="ant-form ant-form-vertical"
                    onFinish={onSubmit}
                    form={form} // like ref
                    layout="vertical"
                    autoComplete="off"
                    initialValues={categoriesOptions}
                  >
                    {console.log("Cat", selectedCategoryId?.data?.position)}
                    <Form.Item
                      hasFeedback
                      label="Category Position"
                      rules={[
                        {
                          required: true,
                          message: "Category Position is Required!",
                        },
                      ]}
                      name="displayOrder"
                    >
                      <Input
                        id="displayOrder"
                        type="number"
                        placeholder="Enter Category Position"
                      />
                    </Form.Item>

                    <div className="buttons-container mt-3">
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="add-submit-btn text-center mr-2"
                      >
                        Submit
                      </Button>
                      <Button
                        type="ghost"
                        htmlType="button"
                        onClick={() => form?.resetFields()}
                        className="reset-submit-btn text-center mr-2"
                      >
                        Reset
                      </Button>
                    </div>
                  </Form>
                </Modal>
              </div>
            }
          />

          <div className="">
            {productsData?.loading ? (
              <Loading />
            ) : (
              <div
                className="product-table-area details-area d-flex-base"
                style={{ alignItems: "inherit" }}
              >
                <div
                  className={`${!categoriesOptions?.length && `hidden`}`}
                  style={{ maxWidth: 210, overflowY: "auto" }}
                >
                  {categoriesOptions?.list?.length ? (
                    <>
                      {/* <b className="mb-10 pb-4">Sub Categories</b> */}
                      {categoriesOptions?.list?.map((category, index) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper pr-0 pl-1"
                            onClick={() =>
                              setSelectedCategory({
                                id: category?.id,
                                name: category.title,
                              })
                            }
                          >
                            {" "}
                            <Tag className="ml-3" color="orange">
                              {category?.position || 0}
                            </Tag>
                            <Avatar
                              shape="circle"
                              size={20}
                              src={category?.image}
                              className="mr-2"
                            />
                            <span className="name major">
                              {category?.title}
                            </span>
                            <Link
                              to="/"
                              className="btn btn-sm pull-right"
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedCategoryId({
                                  id: category?.id,
                                  name: category.title,
                                  position: category.position,
                                });
                              }}
                            >
                              <EditOutlined />
                            </Link>
                          </div>
                        </React.Fragment>
                      ))}
                    </>
                  ) : (
                    <span></span>
                  )}
                </div>
                <div className="d-flex-grow pl-2">
                  <div className="info-body">
                    <div className="details details-area p-2">
                      <small className="">
                        PRODUCT LIST
                        {selectedCategory?.name ? (
                          <>({selectedCategory?.name})</>
                        ) : undefined}
                      </small>
                      <div className="grid-box product-card text-center">
                        {productsData?.data?.products?.length ? (
                          productsData?.data?.products?.map(
                            (product, index) => (
                              <React.Fragment key={index}>
                                <Card
                                  hoverable
                                  cover={
                                    <Image
                                      alt={product?.name}
                                      src={product?.productImage}
                                      style={{
                                        display: "block",
                                        maxHeight: 180,
                                        width: "auto",
                                        margin: "auto",
                                        padding: 1,
                                      }}
                                    />
                                  }
                                >
                                  <div
                                    className="pointer"
                                    onClick={() =>
                                      setSelectedProductSlug(product?.slug)
                                    }
                                  >
                                    <Meta
                                      // title={product?.name}
                                      description={product?.name}
                                      className="mb-1 two-line"
                                    />

                                    {
                                      <div className="text-center border-top">
                                        <small>
                                          <span className="text-nowrap">
                                            MRP: &#2547;
                                            {
                                              product?.variations?.[0]?.price
                                                ?.mrp
                                            }
                                          </span>
                                          <span className="text-nowrap">
                                            TP: &#2547;
                                            {
                                              product?.variations?.[0]?.price
                                                ?.tp
                                            }{" "}
                                          </span>
                                          {product?.variations?.[0]?.price
                                            ?.discountedPrice ? (
                                            <span className="text-nowrap">
                                              <br />
                                              Sale: &#2547;
                                              <del>
                                                {
                                                  product?.variations?.[0]
                                                    ?.price?.discountedPrice
                                                }
                                              </del>
                                            </span>
                                          ) : undefined}
                                        </small>
                                      </div>
                                    }
                                  </div>
                                </Card>
                              </React.Fragment>
                            )
                          )
                        ) : (
                          <Empty />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <PaginationTwo
            {...productsData?.data}
            limit={limit}
            page={productsData?.data?.currentPageNumber || 0}
          />
          <Drawer
            title="Product Details"
            width={900}
            onClose={() => {
              setSelectedProductSlug(null);
            }}
            visible={!!selectedProductSlug}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
            style={{ padding: 0 }}
          >
            {selectedProductForEdit ? (
              <AddProduct
                productSlug={selectedProductForEdit}
                onCloseMethod={onClose}
                // {...createProps}
              />
            ) : (
              <CategoryProductDetails selectedProductId={selectedProductSlug} />
            )}
          </Drawer>
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};

export default ShopCategory;
